<div *adaptLoading="isLoading"
     class="display-cultural-index-organisation-orbit-statistics">
    @if (culturalIndexesHaveBeenRecorded) {
        <div class="card">
            <div class="card-body">
                <div class="active-people">
                    <span class="number"
                          data-test="active-people">{{ statisticsData?.totalPeople }}</span>
                    people with cultural indexes
                </div>
                <div class="ps-2">
                    <span data-test="total-people">{{ activePeopleCount }}</span>
                    people in the organisation
                </div>
                <div class="missing-catchups-accordion pt-3">
                    @if (canSeeData && statisticsAccordion?.length !== 0) {
                        <dx-accordion [dataSource]="statisticsAccordion"
                                      (onContentReady)="onAccordionReady($event)"
                                      [collapsible]="true"
                                      [selectedIndex]="-1"
                                      itemTitleTemplate="itemTitleTemplate"
                                      itemTemplate="itemTemplate">
                            <div *dxTemplate="let item of 'itemTitleTemplate'">
                                {{ item.text }}
                            </div>
                            <div *dxTemplate="let item of 'itemTemplate'">
                                <dx-list [dataSource]="item.people"
                                         itemTemplate="item"
                                         [height]="240">
                                    <div *dxTemplate="let person of 'item'">
                                        <adapt-link-person [person]="person"
                                                           [showImage]="true"></adapt-link-person>
                                    </div>
                                </dx-list>
                            </div>
                        </dx-accordion>
                    }
                </div>
            </div>
        </div>
        @if (canSeeData) {
            <div class="card">
                <div class="card-header">
                    <h2 class="card-title">Overdue catch-ups</h2>
                </div>
                <dx-pie-chart class="overdue-catchups-chart card-body"
                              [dataSource]="statisticsData?.overdueCatchups ?? null"
                              [palette]="CatchupStatusPalette"
                              resolveLabelOverlapping="shift">
                    <dxo-pie-chart-margin [left]="60"></dxo-pie-chart-margin>
                    <dxi-pie-chart-series argumentField="label"
                                          valueField="value">
                        <dxo-pie-chart-label [visible]="true"
                                             textOverflow="none"
                                             position="outside">
                            <dxo-pie-chart-connector [visible]="true"
                                                     [width]="1"></dxo-pie-chart-connector>
                        </dxo-pie-chart-label>
                    </dxi-pie-chart-series>
                    <dxo-pie-chart-legend [visible]="true"></dxo-pie-chart-legend>
                </dx-pie-chart>
            </div>
        }
        <div class="card">
            <div class="card-header">
                <h2 class="card-title">Average Cultural Index</h2>
            </div>
            <div class="card-body">
                <dx-circular-gauge [value]="statisticsData?.averageCulturalIndex">
                    <dxo-circular-gauge-range-container>
                        @for (range of rangeContainer.ranges; track range) {
                            <dxi-circular-gauge-range [startValue]="range.startValue"
                                                      [endValue]="range.endValue"
                                                      [color]="range.color"></dxi-circular-gauge-range>
                        }
                    </dxo-circular-gauge-range-container>
                    <dxo-circular-gauge-scale [startValue]="0"
                                              [endValue]="2"
                                              [tickInterval]="0.1">
                        <dxo-circular-gauge-label [useRangeColors]="true"> </dxo-circular-gauge-label>
                    </dxo-circular-gauge-scale>
                    <dxo-circular-gauge-tooltip [enabled]="true">
                        <dxo-circular-gauge-format type="fixedPoint"
                                                   [precision]="2"> </dxo-circular-gauge-format>
                    </dxo-circular-gauge-tooltip>
                </dx-circular-gauge>
            </div>
        </div>
        <div class="card">
            <div class="card-header">
                <h2 class="card-title">Cultural Index totals</h2>
            </div>
            <div class="card-body">
                <dx-chart class="cultural-index-totals-chart"
                          [dataSource]="[statisticsData]"
                          [rotated]="true">
                    <dxo-chart-common-series-settings argumentField="totalPeople"
                                                      type="bar">
                        <dxo-chart-label [visible]="true"> </dxo-chart-label>
                    </dxo-chart-common-series-settings>
                    <dxo-chart-argument-axis>
                        <dxo-chart-label [visible]="false"> </dxo-chart-label>
                    </dxo-chart-argument-axis>
                    @for (s of series; track s) {
                        <dxi-chart-series [valueField]="s.valueField"
                                          [name]="s.name"
                                          [color]="s.color"> </dxi-chart-series>
                    }
                </dx-chart>
            </div>
        </div>
    } @else {
        <adapt-no-cultural-measurement label="Cultural Indexes"></adapt-no-cultural-measurement>
    }
</div>
